<template>

  <div class="md:mb-10">
    <ShowEntryHeader @open-imprints="openImprints" @open-branches="openBranches" @open-zwe-branches="openZweBranches"
      :ZWEcounter="ZWEcounter" :NoZWEcounter="NoZWEcounter" :ImprintsArrayCounter="ImprintsArrayCounter"
      :showZWEStoreBranches="showZWEStoreBranches" :showStoreBranches="showStoreBranches" />

    <!-- Contact Details -->
    <template v-if="party.contacts[0]">
      <div class="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
        <div class="p-2">
          <p v-for="contacts in party.contacts" :key="contacts.type">
            <span v-if="contacts.type == 'EMAIL'"><strong>{{ $t("Fullentry.Email") }}:</strong> {{ contacts.value
              }}</span>
          </p>
        </div>
        <div class="p-2">
          <p v-for="contacts in party.contacts" :key="contacts.type">
            <span v-if="contacts.type == 'TELEPHONE'"><strong>{{ $t("Fullentry.Phone") }}:</strong> {{ contacts.value
              }}</span>
          </p>
          <p v-for="contacts in party.contacts" :key="contacts.type">
            <span v-if="contacts.type == 'FAX'"><strong>{{ $t("Fullentry.Fax") }}:</strong> {{ contacts.value }}</span>
          </p>
        </div>
      </div>
    </template>

    <!-- if there are isbns  -->
    <template v-if="showIsbn">
      <div class="grid grid-cols-1 pt-0 border-solid border border-gray-300">
        <p class="text-center font-semibold pt-3 pb-3 border-b bg-gray-100">
          {{ $t("Fullentry.IsbnNumbreSingleIsbn") }}
        </p>

        <div class="grid  gap-0 p-2" :class="classForGridISBN">
          {{ sortISBN(party.isbns) }}

          <template v-for="isbn in party.isbns" :key="isbn.id">
            <span class="whitespace-nowrap" v-if="isbn.isbnPrefix">{{ isbn.isbnPrefix }}</span>
            <span class="whitespace-nowrap" v-if="isbn.isbn">{{ isbn.isbn }}</span>
          </template>

        </div>
      </div>
    </template>

    <!-- DE if Debitor or Kreditor exist - show them -->
    <template v-if="party.vnrDebitor || party.vnrKreditor">
      <div class="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
        <template v-if="party.bvMember">
          <div class="px-2 py-4">
            <img v-if="party.mvbId != '5305787'" class="md:h-10 mx-auto" alt="BOEV-Logo"
              src="../../assets/boev-logo.png" />
          </div>
        </template>
        <div class="pt-2">
          <template v-if="party.vnrDebitor">
            <p class="px-2">
              <strong>{{ $t("Fullentry.DebitorVKNr") }}:</strong>
              {{ party.vnrDebitor }}
            </p>
          </template>
          <template v-if="party.vnrKreditor">
            <p class="px-2">
              <strong>{{ $t("Fullentry.KreditorVKNr") }}:</strong>
              {{ party.vnrKreditor }}
            </p>
          </template>
        </div>
      </div>
    </template>

    <!-- AT if Debitor or Kreditor exist - show them -->
    <template v-if="party.vnrDebitorAT || party.vnrKreditorAT">
      <div class="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
        <template v-if="party.vnrDebitorAT || party.vnrKreditorAT">
          <div class="px-2 py-4">
            <img class="h-7 mx-auto" alt="HVB-Logo" src="../../assets/hvb.png" />
          </div>
        </template>
        <div class="pt-2">
          <template v-if="party.vnrDebitorAT">
            <p class="px-2">
              <strong>{{ $t("Fullentry.DebitorVKNr") }}:</strong>
              {{ party.vnrDebitorAT }}
            </p>
          </template>
          <template v-if="party.vnrKreditorAT">
            <p class="px-2">
              <strong>{{ $t("Fullentry.KreditorVKNr") }}:</strong>
              {{ party.vnrKreditorAT }}
            </p>
          </template>
        </div>
      </div>
    </template>

    <!-- CH if Debitor or Kreditor exist - show them -->
    <template v-if="party.vnrDebitorCH || party.vnrKreditorCH">
      <div class="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
        <template v-if="party.vnrDebitorCH || party.vnrKreditorCH">
          <div class="px-2 py-4">
            <img class="h-7 mx-auto" alt="SBVV-Logo" src="../../assets/logo_sbvv.png" />
          </div>
        </template>
        <div class="pt-2">
          <template v-if="party.vnrDebitorCH">
            <p class="px-2">
              <strong>{{ $t("Fullentry.DebitorVKNr") }}:</strong>
              {{ party.vnrDebitorCH }}
            </p>
          </template>
          <template v-if="party.vnrKreditorCH">
            <p class="px-2">
              <strong>{{ $t("Fullentry.KreditorVKNr") }}:</strong>
              {{ party.vnrKreditorCH }}
            </p>
          </template>
        </div>
      </div>
    </template>

    <!-- if Member in VLB - show them -->
    <template v-if="party.businessType == 1 && party.vlbActiveTitles">
      <div class="grid grid-cols-2 border border-gray-300">
        <div class="pt-3">
          <a href="/" class="">
            <img class="w-14 float-right mr-5" alt="VLB-Logo" src="../../assets/vlb-logo.png" /></a>
        </div>
        <div class="p-2" v-if="party.vlbActiveTitles">
          {{ party.vlbActiveTitles }} {{ $t("Fullentry.ActiveTitles") }}
        </div>
      </div>
    </template>

    <!-- Delivery Hints -->
    <template v-if="getDeliveryHintDE || getDeliveryHintAT || getDeliveryHintCH || party.deliveryAddendum">
      <div class="p-2 border border-gray-300">
        <b class="mb-2 block">{{ $t("Fullentry.DeliveryHints") }}:</b>

        <template v-if="getDeliveryHintDE">
          <div class="grid md:grid-cols-2 text-left pb-2">
            <div class="">{{ $t("Party.Germany") }}:</div>
            <div class="md:pl-2">
              <Popover class="text-left text-black">
                <PopoverButton class="underline font-bold text-left border-none outline-none">
                  <p v-html="getDeliveryHintDE.company"></p>
                </PopoverButton>

                <PopoverPanel>
                  <p v-html="getDeliveryHintDE.adress"></p>
                </PopoverPanel>
              </Popover>
            </div>
          </div>
        </template>

        <template v-if="getDeliveryHintAT">
          <div class="grid md:grid-cols-2 text-left border-t border-gray-300 py-2">
            <div class="">
              {{ $t("Party.Austria") }}
            </div>
            <div class="md:pl-2">
              <Popover class="text-left text-black">
                <PopoverButton class="underline font-bold text-left border-none outline-none">
                  <p v-html="getDeliveryHintAT.company"></p>
                </PopoverButton>

                <PopoverPanel>
                  <p v-html="getDeliveryHintAT.adress"></p>
                </PopoverPanel>
              </Popover>
            </div>
          </div>
        </template>

        <template v-if="getDeliveryHintCH">
          <div class="grid md:grid-cols-2 text-left border-t border-gray-300 py-2">
            <div class="">
              {{ $t("Party.Switzerland") }}
            </div>
            <div class="md:pl-2">
              <Popover class="text-left text-black">
                <PopoverButton class="underline font-bold text-left border-none outline-none">
                  <p v-html="getDeliveryHintCH.company"></p>
                </PopoverButton>

                <PopoverPanel class="">
                  <p v-html="getDeliveryHintCH.adress"></p>
                </PopoverPanel>
              </Popover>
            </div>
          </div>
        </template>

        <div class="border-gray-300 border-t" v-if="party.deliveryAddendum">
          <p class="mt-3">
            {{ party.deliveryAddendum }}
          </p>
        </div>
      </div>
    </template>

    <!-- if there are storeBranches  - show them 
    should we use this or not?
    && party.businessType == '2'"
    -->
    <template v-if="AllStoreBranches">
      <div class="relative bg-gray-100 border border-gray-300" id="stores">
        <h3 v-on:click="openBranches" class="cursor-pointer underline text-center font-semibold pt-2 pb-2 border-b">
          {{ NoZWEcounter }} {{ $t("Fullentry.Stores") }}
        </h3>
        <span v-on:click="closeBranches" class="absolute right-0 top-0 p-2 cursor-pointer"
          :class="dropdownStores ? 'd-block' : 'hidden'">
          <font-awesome-icon icon="fa-solid fa-window-close" />
        </span>
      </div>
      <div :class="dropdownStores ? 'd-block' : 'hidden'">
        <div class="grid grid-cols-1 md:grid-cols-3">
          <span class="px-2 py-2 bg-white even:bg-white odd:bg-white text-xs border" v-for="Stores in NoZWEArray"
            :key="Stores.id">
            <router-link :to="{ path: '/party/' + Stores.id }">
              <strong>{{ Stores.cityStreet }}</strong> {{ Stores.street1 }}
            </router-link>
          </span>
        </div>
      </div>

      <!-- ZWE BRANCHES if exist-->
      <div id="ZWEstores" v-if="showZWEStoreBranches">
        <div class="relative" :class="dropdownZWEStores ? 'bg-gray-100 border' : ''">
          <div class="flex justify-center items-center">
            <button v-on:click="openZweBranches"
              class="text-center underline text-black rounded p-1 cursor-pointer m-2">
              {{ ZWEcounter }} {{ $t("Fullentry.ZWEStores") }}
            </button>
          </div>
          <span v-on:click="closeZWEBranches" class="absolute right-0 top-0 p-2 cursor-pointer"
            :class="dropdownZWEStores ? 'd-block' : 'hidden'">
            <font-awesome-icon icon="fa-solid fa-window-close" />
          </span>
        </div>
        <div :class="dropdownZWEStores ? 'd-block' : 'hidden'">
          <div class="grid grid-cols-1 md:grid-cols-3">
            <span class="px-2 py-2 bg-white even:bg-white odd:bg-white text-xs border" v-for="Stores in ZWEArray"
              :key="Stores.id">
              <router-link :to="{ path: '/party/' + Stores.id }">
                {{ Stores.shortNameVLB }}
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </template>

    <!-- Memberships BAG , GOI, GLN, Tax-ID, MVB-ID -->
    <template v-if="party.doiPrefix || party.GLN || party.taxId || party.mvbId">
      <div class="border border-gray-300 bg-gray-100">
        <div class="p-2 grid" :class="classForMemberships">
          <p class="text-center" v-if="party.taxId">
            <strong>{{ $t("Fullentry.TaxId") }}:</strong> {{ party.taxId }}
          </p>
          <p class="text-center" v-if="party.GLN">
            <strong>{{ $t("Fullentry.Member.GLN") }}:</strong> {{ party.GLN }}
          </p>
          <p class="text-center" v-if="party.doiPrefix">
            <strong>{{ $t("Fullentry.Member.DOI") }}:</strong> {{ party.doiPrefix }}
          </p>
          <p class="text-center" v-if="party.mvbId">
            <strong>{{ $t("Fullentry.Member.MVBId") }}:</strong> {{ party.mvbId }}
          </p>
        </div>
      </div>
    </template>

    <template v-if="party.bagDebitorAttribute || party.bagKreditorAttribute">
      <div class="border border-gray-300">
        <div class="p-2 grid grid-cols-2" v-if="party.bagDebitorAttribute || party.bagKreditorAttribute">
          <div>
            <img class="h-10 mx-auto" alt="BAG-Logo" src="../../assets/bag-logo.png" />
          </div>
          <div class="px-2 mt-4">
            <span v-if="party.bagDebitorAttribute">
              {{ $t("Fullentry.Member.BAGDebitor") }}
            </span>
            <span v-if="party.bagDebitorAttribute && party.bagKreditorAttribute">
              &nbsp;{{ $t("Fullentry.Member.and") }}&nbsp;
            </span>
            <span v-if="party.bagKreditorAttribute">
              {{ $t("Fullentry.Member.BAGKreditor") }}
            </span>
          </div>
        </div>
      </div>
    </template>

    <!------------- Trade Magazin ------------->
    <template v-if="party.fzPrbAttribute || party.vStrPrbAttribute || party.vFZPrbAttribute">
      <div class="border border-gray-300">
        <div class="text-center font-semibold pt-3 pb-0 mt-2">
          <span class="">{{ $t("Fullentry.Magazin") }}</span>
        </div>

        <div class="p-2 grid" :class="classForTradeMagazin">
          <p class="text-center" v-if="party.fzPrbAttribute">
            {{ $t("Fullentry.Magazin.fzPrbAttribute") }}
          </p>
          <p class="text-center" v-if="party.vStrPrbAttribute">
            {{ $t("Fullentry.Magazin.vStrPrbAttribute") }}
          </p>
          <p class="text-center" v-if="party.vFZPrbAttribute">
            {{ $t("Fullentry.Magazin.vFZPrbAttribute") }}
          </p>
        </div>
      </div>
    </template>

    <!-- if there are imprints and businesstype is 1 (publisher) - show them -->
    <template v-if="showImprints && party.businessType == '1'">
      <div class="relative" id="imprints">
        <div v-on:click="openImprints" class="text-center font-semibold pt-3 pb-3 border-b border-x mt-0 bg-gray-100">
          <span class="cursor-pointer underline" @click="$emit('openImprints')">{{ ImprintsArrayCounter }} {{
            $t("Fullentry.OpenImprints") }}</span>
        </div>
        <span v-on:click="closeImprints" class="absolute right-0 top-0 p-4 cursor-pointer"
          :class="dropdownImprints ? 'd-block' : 'hidden'">
          <font-awesome-icon icon="fa-solid fa-window-close" />
        </span>
      </div>

      <div class="" :class="dropdownImprints ? 'd-block' : 'hidden'">
        <div class="grid grid-cols-1 md:grid-cols-3">
          <span class="px-2 py-2 bg-white even:bg-white odd:bg-white text-xs border" v-for="imprints in ImprintsArray"
            :key="imprints.id">
            <router-link v-if="imprints.id" :to="{ path: '/party/' + imprints.id }">{{
              imprints.companyName
            }}</router-link>
          </span>
        </div>
      </div>
      <div class="text-center mt-4" v-if="url">
        <a :href="url" target="_blank">
          <button class="text-center border border-black text-black rounded pl-10 py-2 pr-10 w-auto">Mehr auf <img
              class="h-5 mb-1" src="../../assets/logo-bbl.jpg" alt="Börsenblatt Logo" /></button>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { usePartyStore } from "../../stores/PartyStore";
import ShowEntryHeader from "./../../components/ShowEntryHeader.vue";
import deliveryCodelistDE from "../../codelists/deliveryHints/de.deliverhintsDe.json"; //TODO: Load dynamcially the file for current location - at the moment always DE
import deliveryCodelistATCH from "../../codelists/deliveryHints/de.deliverhintsAtCh.json";
export default {
  name: "TheFullEntry",

  data() {
    return {

      urlMap: {           // URL-Mapping: mvb-ids zu URLs
        "5108280": "https://www.boersenblatt.net/thema/bastei-luebbe",
        "5106260": "https://www.boersenblatt.net/thema/beuth",
        "5106160": "https://www.boersenblatt.net/thema/ch-beck",
        "5106586": "https://www.boersenblatt.net/thema/ch-beck",
        "5106693": "https://www.boersenblatt.net/thema/coppenrath-verlag",
        "5101070": "https://www.boersenblatt.net/thema/cornelsen",
        "5107430": "https://www.boersenblatt.net/thema/de-gruyter",
        "5106813": "https://www.boersenblatt.net/thema/dfv-mediengruppe",
        "5106923": "https://www.boersenblatt.net/thema/droemer-knaur",
        "5106842": "https://www.boersenblatt.net/thema/dtv",
        "5107659": "https://www.boersenblatt.net/thema/elsevier",
        "5107405": "https://www.boersenblatt.net/thema/graefe-und-unzer",
        "5105873": "https://www.boersenblatt.net/thema/haufe",
        "82370": "https://www.boersenblatt.net/thema/herder",
        "5108040": "https://www.boersenblatt.net/thema/klett",
        "5108112": "https://www.boersenblatt.net/thema/korsch",
        "5108531": "https://www.boersenblatt.net/thema/nomos",
        "5103925": "https://www.boersenblatt.net/thema/paul-pietsch-verlage",
        "5109269": "https://www.boersenblatt.net/thema/penguin-random-house",
        "5108649": "https://www.boersenblatt.net/thema/piper",
        "5108300": "https://www.boersenblatt.net/thema/ravensburger",
        "108800": "https://www.boersenblatt.net/thema/rowohlt",
        "5108458": "https://www.boersenblatt.net/thema/rudolf-mueller-mediengruppe",
        "5107141": "https://www.boersenblatt.net/thema/s-fischer",
        "5108985": "https://www.boersenblatt.net/thema/springer",
        "81942": "https://www.boersenblatt.net/thema/suedwestdeutsche-medienholding-swmh",
        "5109084": "https://www.boersenblatt.net/thema/thieme",
        "5109085": "https://www.boersenblatt.net/thema/thienemann-verlage",
        "5109138": "https://www.boersenblatt.net/thema/ullstein",
        "5005532": "https://www.boersenblatt.net/thema/vogel",
        "5109304": "https://www.boersenblatt.net/thema/walhalla",
        "82292": "https://www.boersenblatt.net/thema/weka",
        "5151472": "https://www.boersenblatt.net/thema/westermann",
        "5109189": "https://www.boersenblatt.net/thema/wiley-vch",
        "5108278": "https://www.boersenblatt.net/thema/wolters-kluwer"
      },
      button: "btn btn-secondary",
      partyStore: null,
      dropdownImprints: false,
      dropdownStores: false,
      dropdownZWEStores: false,
      ZWEcounter: 0,
      ZWEArray: {},
      NoZWEcounter: 0,
      NoZWEArray: {},
      ImprintsArray: {},
      ImprintsArrayCounter: 0
    };
  },

  components: {
    ShowEntryHeader,
  },
  methods: {
    sortISBN(isbnarray) {
      isbnarray.sort((a, b) => {
        // extract isbn and isbnprefix
        const isbnA = a.isbn || a.isbnPrefix || "";
        const isbnB = b.isbn || b.isbnPrefix || "";

        if (isbnA < isbnB) {
          return -1;
        }
        if (isbnA > isbnB) {
          return 1;
        }
        return 0;
      });
    },

    openImprints() {
      this.dropdownImprints = true;
      this.$scrollTo("#imprints");
    },
    closeImprints() {
      this.dropdownImprints = false;
    },
    openBranches() {
      this.dropdownStores = true;
      this.$scrollTo("#stores");
    },
    closeBranches() {
      this.dropdownStores = false;
    },

    openZweBranches() {
      this.dropdownZWEStores = true;
      this.$scrollTo("#ZWEstores");
    },
    closeZWEBranches() {
      this.dropdownZWEStores = false;
    },

    FilterImprints() {
      let jsonObj = this.party;
      let y = 0;
      // let emptyname = 0;
      // console.log("filter imprints func " +jsonObj.imprints.length);
      for (var i = 0; i < jsonObj.imprints.length; i++) {
        let id = jsonObj.imprints[i].id;
        let companyName = jsonObj.imprints[i].companyName;

        if (companyName) {
          // search for [9] in company name. these entries are blocked an should not be displayed
          let matchResult = companyName.match(/\[9\]/);
          if (!matchResult) {
            this.ImprintsArray["imprint" + y] = {
              id: id,
              companyName: companyName,
            };
            this.ImprintsArrayCounter++;
            y++;
            // console.log("ImprintsArrayCounter" +this.ImprintsArrayCounter);
          }
        } else {
          // if we need this sometime
          // count empty shortnameVLB OR empty companyName
          // emptyname++;
          // console.log(emptyname);
        }
      }

      return this.ImprintsArray;
    },

    StoreBranches() {
      let jsonObj = this.party;
      let y = 0;
      // let emptyname = 0;
      for (var i = 0; i < jsonObj.storeBranches.length; i++) {
        let id = jsonObj.storeBranches[i].id;
        let shortNameVLB = jsonObj.storeBranches[i].shortNameVLB;
        let companyName = jsonObj.storeBranches[i].companyName;
        let mvbId = jsonObj.storeBranches[i].mvbId;
        let street1 = jsonObj.storeBranches[i].postalAddress.street1;
        let cityStreet = jsonObj.storeBranches[i].postalAddress.cityStreet;

        if (shortNameVLB || companyName) {
          var searchstr = /ZWE Mayersche Thalia,|ZWE,/;
          if (!searchstr.test(shortNameVLB)) {
            this.NoZWEArray["nozwe" + y] = {
              id: id,
              mvbId: mvbId,
              shortNameVLB: shortNameVLB,
              companyName: companyName,
              street1: street1,
              cityStreet: cityStreet,
            };
            this.NoZWEcounter++;
            y++;
            // console.log("NoZWEcounter" +this.NoZWEcounter);
          }
        } else {
          // if we need this sometime
          // count empty shortnameVLB OR empty companyName
          // emptyname++;
          // console.log("emptyname"+emptyname);
        }
      }

      return this.NoZWEArray;
    },

    ZweStoreBranches() {
      let jsonObj = this.party;
      let y = 0;

      for (var i = 0; i < jsonObj.storeBranches.length; i++) {
        let shortNameVLB = jsonObj.storeBranches[i].shortNameVLB;
        let id = jsonObj.storeBranches[i].id;
        let mvbId = jsonObj.storeBranches[i].mvbId;
        if (shortNameVLB) {
          var searchstr = /ZWE Mayersche Thalia,|ZWE,/;
          if (searchstr.test(shortNameVLB)) {
            // str_replace zwe and more
            shortNameVLB = shortNameVLB.replace(/\s\d+$/, "");
            shortNameVLB = shortNameVLB.replace(/ZWE Mayersche Thalia, Mayersche/g, "");
            shortNameVLB = shortNameVLB.replace(/ZWE, Thalia Mayersche/g, "");
            shortNameVLB = shortNameVLB.replace(/ZWE, Thalia/g, "");
            shortNameVLB = shortNameVLB.replace(/ZWE, Wittwer Thalia/g, "");
            shortNameVLB = shortNameVLB.replace(/ZWE, Wittwer-Thalia/g, "");
            shortNameVLB = shortNameVLB.replace(/ZWE,/g, "");

            this.ZWEArray["zwe" + y] = {
              id: id,
              mvbId: mvbId,
              shortNameVLB: shortNameVLB,
            };

            this.ZWEcounter++;
            y++;
            // console.log("ZWEcounter" +this.ZWEcounter);
          }
        }
      }

      // Sortieren nach dem Wert von shortNameVLB
      const sortedArray = Object.entries(this.ZWEArray).sort((a, b) =>
        a[1].shortNameVLB.localeCompare(b[1].shortNameVLB)
      );

      // Konvertieren des sortierten Arrays zurück in ein Objekt
      this.ZWEArray = Object.fromEntries(sortedArray);

      return this.ZWEArray;
    },
  },

  computed: {
    party() {
      return this.partyStore.party;
    },
    url() {
      return this.urlMap[this.party.mvbId] || null;  // Gibt die URL zurück oder null, wenn nicht vorhanden
    },
    showImprints() {
      return this.ImprintsArrayCounter > 0 ? true : false;
    },
    AllStoreBranches() {
      return this.party.storeBranches.length > 0 ? true : false;
    },
    showZWEStoreBranches() {
      return this.ZWEcounter > 0 ? true : false;
    },
    showStoreBranches() {
      return this.NoZWEcounter > 0 ? true : false;
    },
    showIsbn() {
      return this.party.isbns.length > 0 ? true : false;
    },
    countStoreBranches() {
      return this.party.storeBranches.length;
    },

    classForMemberships() {
      if (this.party.doiPrefix && this.party.taxId && this.party.GLN && this.party.mvbId)
        return "md:grid-cols-4";

      // three numbers
      if (!this.party.doiPrefix && this.party.taxId && this.party.GLN && this.party.mvbId)
        return "md:grid-cols-3";
      if (this.party.doiPrefix && !this.party.taxId && this.party.GLN && this.party.mvbId)
        return "md:grid-cols-3";
      if (this.party.doiPrefix && this.party.taxId && !this.party.GLN && this.party.mvbId)
        return "md:grid-cols-3";
      if (this.party.doiPrefix && this.party.taxId && this.party.GLN && !this.party.mvbId)
        return "md:grid-cols-3";

      // two numbers
      if (this.party.doiPrefix && this.party.taxId && !this.party.GLN && !this.party.mvbId)
        return "md:grid-cols-2";
      if (this.party.doiPrefix && !this.party.taxId && this.party.GLN && !this.party.mvbId)
        return "md:grid-cols-2";
      if (this.party.doiPrefix && !this.party.taxId && !this.party.GLN && this.party.mvbId)
        return "md:grid-cols-2";
      if (!this.party.doiPrefix && this.party.taxId && this.party.GLN && !this.party.mvbId)
        return "md:grid-cols-2";
      if (!this.party.doiPrefix && this.party.taxId && !this.party.GLN && this.party.mvbId)
        return "md:grid-cols-2";
      if (!this.party.doiPrefix && !this.party.taxId && this.party.GLN && this.party.mvbId)
        return "md:grid-cols-2";

      // one number
      if (!this.party.doiPrefix && !this.party.taxId && !this.party.mvbId && this.party.GLN)
        return "md:grid-cols-1";
      if (this.party.doiPrefix && !this.party.taxId && !this.party.mvbId && !this.party.GLN)
        return "md:grid-cols-1";
      if (!this.party.doiPrefix && this.party.taxId && !this.party.mvbId && !this.party.GLN)
        return "md:grid-cols-1";
      if (!this.party.doiPrefix && !this.party.taxId && this.party.mvbId && !this.party.GLN)
        return "md:grid-cols-1";


      return "md:grid-cols-1";
    },

    classForTradeMagazin() {
      if (
        this.party.fzPrbAttribute &&
        this.party.vStrPrbAttribute &&
        this.party.vFZPrbAttribute
      )
        return "md:grid-cols-3";

      if (
        !this.party.fzPrbAttribute &&
        this.party.vStrPrbAttribute &&
        this.party.vFZPrbAttribute
      )
        return "md:grid-cols-2";
      if (
        this.party.fzPrbAttribute &&
        !this.party.vStrPrbAttribute &&
        this.party.vFZPrbAttribute
      )
        return "md:grid-cols-2";
      if (
        this.party.fzPrbAttribute &&
        this.party.vStrPrbAttribute &&
        !this.party.vFZPrbAttribute
      )
        return "md:grid-cols-2";

      if (
        !this.party.fzPrbAttribute &&
        !this.party.vStrPrbAttribute &&
        this.party.vFZPrbAttribute
      )
        return "md:grid-cols-1";
      if (
        this.party.fzPrbAttribute &&
        !this.party.vStrPrbAttribute &&
        !this.party.vFZPrbAttribute
      )
        return "md:grid-cols-1";
      if (
        !this.party.fzPrbAttribute &&
        this.party.vStrPrbAttribute &&
        !this.party.vFZPrbAttribute
      )
        return "md:grid-cols-1";

      return "md:grid-cols-1";
    },

    classForGridISBN() {
      if (this.party.isbns.length == 1) return "md:grid-cols-1 text-center";
      if (this.party.isbns.length == 2) return "md:grid-cols-2 text-center";
      if (this.party.isbns.length == 3) return "md:grid-cols-3 text-center";
      if (this.party.isbns.length == 4) return "md:grid-cols-4 text-center";
      if (this.party.isbns.length == 5) return "md:grid-cols-5 text-center";
      return "md:grid-cols-6";
    },

    getDeliveryHintDE() {
      let partyDeliveryHint = this.party.sigelDE;
      const found = Object.keys(deliveryCodelistDE).find(
        (element) => element == partyDeliveryHint
      );
      if (found) {
        if (partyDeliveryHint) {
          let deliveryhintDEadress = deliveryCodelistDE[partyDeliveryHint]["adress"];
          let deliveryhintDEcompany = deliveryCodelistDE[partyDeliveryHint]["company"];

          if (deliveryhintDEadress && deliveryhintDEcompany) {
            let deliveryDEhint = {
              adress: deliveryhintDEadress,
              company: deliveryhintDEcompany,
            };
            return deliveryDEhint;
          }
        }
        return false;
      }
      return false;
    },

    getDeliveryHintAT() {
      let partyDeliveryHint = this.party.sigelAT;
      const found = Object.keys(deliveryCodelistATCH).find(
        (element) => element == partyDeliveryHint
      );
      if (found) {
        if (partyDeliveryHint) {
          let deliveryhintATCHadress = deliveryCodelistATCH[partyDeliveryHint]["adress"];
          let deliveryhintATCHcompany =
            deliveryCodelistATCH[partyDeliveryHint]["company"];
          if (deliveryhintATCHadress && deliveryhintATCHcompany) {
            let deliveryATCHhint = {
              adress: deliveryhintATCHadress,
              company: deliveryhintATCHcompany,
            };
            return deliveryATCHhint;
          }
        }
        return false;
      }
      return false;
    },

    getDeliveryHintCH() {
      let partyDeliveryHint = this.party.sigelCH;
      const found = Object.keys(deliveryCodelistATCH).find(
        (element) => element == partyDeliveryHint
      );
      if (found) {
        if (partyDeliveryHint) {
          let deliveryhintATCHadress = deliveryCodelistATCH[partyDeliveryHint]["adress"];
          let deliveryhintATCHcompany =
            deliveryCodelistATCH[partyDeliveryHint]["company"];
          if (deliveryhintATCHadress && deliveryhintATCHcompany) {
            let deliveryATCHhint = {
              adress: deliveryhintATCHadress,
              company: deliveryhintATCHcompany,
            };
            return deliveryATCHhint;
          }
        }
        return false;
      }
      return false;
    },
  },

  async created() {
    this.partyStore = usePartyStore();
    this.FilterImprints();
    this.StoreBranches();
    this.ZweStoreBranches();
  },
};
</script>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
</script>
